// Login-related action types
export const POST_LOGIN_REQUEST     = "POST_LOGIN_REQUEST";
export const POST_LOGIN_SUCCESS     = "POST_LOGIN_SUCCESS";
export const POST_LOGIN_FAILURE     = "POST_LOGIN_FAILURE";
export const USER_LOADED            = "USER_LOADED";
export const LOGOUT                 = "LOGOUT";
